<div class="d-flex"
     [class]="(!multiSelect || inEditMode) ? 'align-items-center' : 'align-items-baseline'">
  @if (inEditMode) {
    <div class="flex-grow-1 shrinkable-flex-item">
      <app-ace-select
          #ticketsSelect
          [formControl]="formControl"
          [placeholder]="placeholder || ('Type to search tickets' | messageTranslate)"
          [items]="availableTickets"
          [multiSelect]="multiSelect"
          [loading]="ticketsLoading || ticketSearchLoading"
          [appendTo]="appendTo"
          [clearable]="clearable"
          [hideSelected]="hideSelected"
          [typeahead]="typeahead"
          [compareWith]="compareFn"
          [closeOnSelect]="!multiSelect"
          (touched)="onSelectTouched()"
          (openEvent)="onOpen()"
          (closeEvent)="onClose()"
          (clear)="onClear()"
          (scrollToEnd)="onScrollToEnd()">

        <ng-template #labelTemplate let-ticket="item">
          <ng-template [ngTemplateOutlet]="ticketContentTemplate"
                       [ngTemplateOutletContext]="{ticket: ticket, truncateSummary: true, nonExpandable: true}"/>
        </ng-template>

        <ng-template #optionTemplate let-ticket="item">
          <ng-template [ngTemplateOutlet]="ticketContentTemplate"
                       [ngTemplateOutletContext]="{ticket: ticket, truncateSummary: false}"/>
        </ng-template>

        <ng-template #multiLabelTemplate let-tickets="items" let-clear="clear">
          <!-- `multiLabelTemplate` is used inside `.ng-value-container` which has flex display.
            Since it's possible for the content of this flex item to be longer, we use `.min-width-0` here
            to allow flex to shrink this flex item smaller than its content -->
          <div class="d-block min-width-0">
            @for (ticket of tickets; track ticket.ticket_id) {
              <div class="ng-value">
                <ng-template [ngTemplateOutlet]="multiSelectTicketItemTemplate"
                             [ngTemplateOutletContext]="{ticket: ticket, clear: clear, clearableResult: canClearSelectionFn ? canClearSelectionFn(ticket) : null}"/>
              </div>
            }
          </div>
        </ng-template>
      </app-ace-select>
    </div>
  } @else if (multiSelect) {
    @if (formControl.value?.length > 0) {
      <div class="min-width-0 d-flex flex-column gap-2">
        @for (ticket of formControl.value; track ticket.ticket_id) {
          <ng-template [ngTemplateOutlet]="ticketContentTemplate"
                       [ngTemplateOutletContext]="{ticket: ticket, truncateSummary: true}"/>
        }
      </div>
    } @else {
      <ng-template [ngTemplateOutlet]="emptyTicketSelectionReadonlyTemplate"/>
    }
  } @else {
    @if (formControl.value; as ticket) {
      <ng-template [ngTemplateOutlet]="ticketContentTemplate"
                   [ngTemplateOutletContext]="{ticket: ticket, truncateSummary: true}"/>
    } @else {
      <ng-template [ngTemplateOutlet]="emptyTicketSelectionReadonlyTemplate"/>
    }
  }

  @if (canChangeEditMode || saving) {
    <div class="ms-1">
      @if ((multiSelect && inEditMode) || saving) {
        <fa-icon [appShowFaSpinner]="saving"
                 icon="check-circle"
                 class="text-body-secondary clickable small"
                 [fixedWidth]="true"
                 (click)="onSaveClicked()"/>
      }
      @if (!saving && !inEditMode) {
        <fa-icon icon="pencil-alt"
                 class="text-body-secondary clickable small"
                 [title]="'Edit Linked ticketType' | messageTranslate:{ticketType: getTicketTypeDisplayText(ticketType, multiSelect)}"
                 [fixedWidth]="true"
                 (click)="setEditable(true)"/>
      }
      @if (!saving && inEditMode) {
        <fa-icon icon="times"
                 class="text-body-secondary clickable small"
                 [fixedWidth]="true"
                 (click)="cancelEdit()"/>
      }
    </div>
  }
</div>

<ng-template #ticketContentTemplate let-ticket="ticket" let-truncateSummary="truncateSummary" let-nonExpandable="nonExpandable">
  @if (ticket) {
    <div class="min-width-0" [ngClass]="{'clickable': canViewTicket()}" (click)="onViewTicket(ticket, $event)">
      @if (truncateSummary) {
        @if (!nonExpandable) {
          <app-ellipsis [text]="ticket.summary"
                        [textUnhiddenClass]="'text-break'">
            <ng-container ngProjectAs="[postContent]" [ngTemplateOutlet]="postSummaryInfoTemplate" [ngTemplateOutletContext]="{ticket: ticket}"/>
          </app-ellipsis>
        } @else {
          <div class="d-flex">
            <span class="pe-1 text-truncate">{{ticket.summary}}</span>
            <ng-template [ngTemplateOutlet]="postSummaryInfoTemplate" [ngTemplateOutletContext]="{ticket: ticket}"/>
          </div>
        }
      } @else {
        <span class="pe-1 text-break text-wrap">{{ticket.summary}}</span>
        <ng-template [ngTemplateOutlet]="postSummaryInfoTemplate" [ngTemplateOutletContext]="{ticket: ticket}"/>
      }
    </div>
  }
</ng-template>

<ng-template #postSummaryInfoTemplate let-ticket="ticket">
  @if (ticketType === TicketType.ALERT) {
    <app-alert-ticket-status class="mx-1"
                             [ticket]="ticket"
                             [alwaysDisplayFaultStatus]="true"/>
  } @else {
    <app-ticket-status [ticket]="ticket" class="mx-1"/>
  }
  @if (tasksById?.get(ticket.rule_id)?.task_state === false) {
    <span class="ms-1 badge rounded-pill text-bg-secondary">
      {{'Stopped' | messageTranslate}}
    </span>
  }
  @if (!inEditMode && !saving && ticketType === TicketType.ALERT) {
    @if (tasksLoading) {
      <fa-icon icon="spinner" class="mx-1" animation="spin"/>
    } @else {
      @if (getChartLinkParamsForTicket(ticket); as queryParams) {
        <a class="text-primary text-nowrap"
          target="_blank"
          [title]="'Click to open chart in a new tab' | messageTranslate"
          [routerLink]="['/charts']"
          [queryParams]="queryParams"
          (click)="$event.stopPropagation();">
          <fa-icon icon="chart-line" class="mx-1" size="sm" [fixedWidth]="true"/>
          <span class="d-none d-sm-inline">{{'View Chart' | messageTranslate}}</span></a>
      } @else {
        <span class="ms-1 badge rounded-pill text-bg-danger">
          {{('Rule ruleId not found' | messageTranslate:{ruleId: ticket.rule_id})}}
        </span>
      }
    }
  }
</ng-template>

<ng-template #emptyTicketSelectionReadonlyTemplate>
  {{'Unlinked' | messageTranslate}}
</ng-template>

<ng-template #multiSelectTicketItemTemplate let-ticket="ticket" let-clear="clear" let-clearableResult="clearableResult">
  <div class="d-flex align-items-center">
    @if (!clearableResult?.nonClearable) {
      <span class="ng-value-icon left"
            aria-hidden="true"
            (click)="clear(ticket)">&times;</span>
    }
    <span class="ng-value-label shrinkable-flex-item" [title]="ticket.summary + (clearableResult?.nonClearable ? (' (' + (clearableResult?.reason | messageTranslate) + ')') : '')">
      <ng-template [ngTemplateOutlet]="ticketContentTemplate"
                   [ngTemplateOutletContext]="{ticket: ticket, truncateSummary: true, nonExpandable: true}"/>
    </span>
  </div>
</ng-template>
